import { ModuleV1Read } from '@ca/core/models';

export const commonFeatureKey = 'common';

export interface CommonState {
    loading: boolean;
    systemModules: ModuleV1Read[];
    error?: unknown;
    loadSystemModulesError: boolean;
    loadSystemModulesSuccess: boolean;
}

export const initialCommonState: CommonState = {
    loading: false,
    systemModules: [],
    error: undefined,
    loadSystemModulesError: false,
    loadSystemModulesSuccess: false,
};
